import {createElement, FC, PropsWithChildren} from 'external/react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import {omit} from 'external/lodash'

import {faBox} from '@fortawesome/free-solid-svg-icons/faBox'
import {faCirclePlus}from '@fortawesome/free-solid-svg-icons/faCirclePlus'
import {faCircleExclamation} from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner'
import {faUserPlus} from '@fortawesome/free-solid-svg-icons/faUserPlus'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faUserTie} from '@fortawesome/free-solid-svg-icons/faUserTie'
import {faXmark} from '@fortawesome/free-solid-svg-icons/faXmark'
import {faHouse} from '@fortawesome/free-solid-svg-icons/faHouse'
import {faUsers} from '@fortawesome/free-solid-svg-icons/faUsers'
import {faHandHoldingDollar} from '@fortawesome/free-solid-svg-icons/faHandHoldingDollar'
import {faHeadset} from '@fortawesome/free-solid-svg-icons/faHeadset'
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars'
import {faRightFromBracket} from '@fortawesome/free-solid-svg-icons/faRightFromBracket'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faCircleUser} from '@fortawesome/free-solid-svg-icons/faCircleUser'
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faLocationDot} from '@fortawesome/free-solid-svg-icons/faLocationDot'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faCircleCheck} from '@fortawesome/free-solid-svg-icons/faCircleCheck'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import {faPenToSquare} from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import {faTrashCan} from '@fortawesome/free-solid-svg-icons/faTrashCan'
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye'
import {faEyeSlash} from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import {faHandshake} from '@fortawesome/free-solid-svg-icons/faHandshake'
import {faGraduationCap} from '@fortawesome/free-solid-svg-icons/faGraduationCap'
import {faPersonChalkboard} from '@fortawesome/free-solid-svg-icons/faPersonChalkboard'
import {faEllipsisVertical} from '@fortawesome/free-solid-svg-icons/faEllipsisVertical'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons/faCalendarDays'
import { faPuzzlePiece } from '@fortawesome/free-solid-svg-icons/faPuzzlePiece'
import { faCreditCard} from '@fortawesome/free-solid-svg-icons/faCreditCard'
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons/faClockRotateLeft'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faDollar} from '@fortawesome/free-solid-svg-icons/faDollar'

const icons = {
    faBox,
    faCirclePlus,
    faCircleExclamation,
    faSpinner,
    faUserPlus,
    faCheck,
    faUserTie,
    faXmark,
    faHouse,
    faUsers,
    faHandHoldingDollar,
    faHeadset,
    faBars,
    faUser,
    faRightFromBracket,
    faCircleUser,
    faShoppingCart,
    faEnvelope,
    faLocationDot,
    faCircleCheck,
    faPhone,
    faChevronLeft,
    faPenToSquare,
    faTrashCan,
    faEye,
    faEyeSlash,
    faGraduationCap,
    faHandshake,
    faPersonChalkboard,
    faEllipsisVertical,
    faCalendarDays,
    faCreditCard,
    faClockRotateLeft,
    faPuzzlePiece,
    faExclamationTriangle,
    faDollar
}

type IconName = keyof typeof icons

type IconProps = { name: IconName }

const Icon : FC<PropsWithChildren<IconProps & Partial<FontAwesomeIconProps>>> = props => {
    const icon = icons[props.name]
    const iconProps = omit({icon, ...props}, ['name'])
    return createElement(FontAwesomeIcon, iconProps, props.children)
}

export type {IconName}
export {Icon as default, icons}